import { URL } from '@core/constants/url.constant';
import { ApiValidate } from '@core/decorators/ApiValidate.decorator';
import { apiService } from '@core/services/Api.service';
import { whoAmIResponseSchema } from '@shared/schemas/whoAmI.schema';
import type { TWhoAmIResponse } from '@pages/Users/models/whoAmI.model';

class WhoAmIService {
  @ApiValidate(whoAmIResponseSchema)
  public getWhoAmI() {
    return apiService.get<TWhoAmIResponse>({
      url: `${URL.users}/me`
    });
  }
}

const whoAmIService = new WhoAmIService();

export { whoAmIService };
